import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import fetchAllBillsWithSession from '../utils/fetchAllBillsWithSession';
import VoteHistory from './Modals/VoteHistory';
import {
  MDBSpinner,
  MDBDropdown,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBDropdownItem,
  MDBInputGroup,
  MDBInput, 
  MDBIcon
} from 'mdb-react-ui-kit';

function BillSearchDropdown({ filterSession, relevantBills }) {
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [allOptions, setAllOptions] = useState([]); 
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedBill, setSelectedBill] = useState(null);

  // Fetch bills on mount
  useEffect(() => {
    const fetchBills = async () => {
      try {
        setLoading(true);
        //const bills = await fetchAllBillsWithSession(filterSession.id);
        const formattedOptions = relevantBills
          .filter(bill => bill && bill.billType && bill.billNumber)
          .map(bill => ({
            label: `${bill.billType?.code || ''} ${bill.billNumber || ''}`,
            value: bill.id,
            billData: bill
          }))
          .filter(option => option && option.label);
  
        // Natural sort by billType code and then billNumber
        const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
        formattedOptions.sort((a, b) => {
          const aType = a.billData.billType?.code || '';
          const bType = b.billData.billType?.code || '';
          const typeCompare = collator.compare(aType, bType);
          if (typeCompare !== 0) return typeCompare;
  
          const aNum = a.billData.billNumber || '';
          const bNum = b.billData.billNumber || '';
          return collator.compare(aNum, bNum);
        });
  
        setAllOptions(formattedOptions);
        setFilteredOptions(formattedOptions);
      } catch (error) {
        console.error('Error fetching bills:', error);
        setAllOptions([]);
        setFilteredOptions([]);
      } finally {
        if(relevantBills.length)
          setLoading(false);
      }
    };
    fetchBills();
  }, [filterSession.id, relevantBills]);

  useEffect(() => {
    const newFilteredOptions = allOptions.filter(option =>
      option?.label?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredOptions(newFilteredOptions);
  }, [searchTerm, allOptions]);

  const handleBillSelect = (value, billData) => {
    if (value) {
      setSelectedBill({
        id: value,
        number: `${billData.billType?.code || ''} ${billData.billNumber || ''}`
      });
    }
  };

  return (
    <>
      <MDBDropdown isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} className='d-flex w-auto justify-content-end'>
        <MDBDropdownToggle>
          <i className="fa-light fa-check-to-slot"></i> Vote History
        </MDBDropdownToggle>
        <MDBDropdownMenu className="p-3">
          <MDBInputGroup
            noBorder
            textBefore={<MDBIcon fas icon="search" />}
          >
            <MDBInput
              label='Search Bills'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault(); // stop default form/submit/blur behavior
                  e.stopPropagation(); // also prevent bubbling to dropdown
                }
              }}
            />
          </MDBInputGroup>
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {loading ? (
              <div className="text-center pt-3">
                <MDBSpinner size='sm' role='status'>
                  <span className='visually-hidden'>Loading...</span>
                </MDBSpinner>
                <div>Loading Bills...</div>
              </div>
            ) : filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <MDBDropdownItem
                  key={option.value}
                  link
                  onClick={() => handleBillSelect(option.value, option.billData)}
                >
                  {option.label}
                </MDBDropdownItem>
              ))
            ) : (
              <MDBDropdownItem link disabled>
                {searchTerm ? 'No bills found' : 'Type to search bills'}
              </MDBDropdownItem>
            )}
          </div>
        </MDBDropdownMenu>
      </MDBDropdown>

      {selectedBill && (
        <VoteHistory
          basicModal={!!selectedBill}
          setBasicModal={() => setSelectedBill(null)}
          billId={selectedBill.id}
          billNumber={selectedBill.number}
        />
      )}
    </>
  );
}

export default BillSearchDropdown;